/**
 * Working days for leave deduction: Monday–Friday only, excluding dates in `holidays`.
 */

export async function fetchHolidayDatesInRange(execute, authUrl, startYmd, endYmd) {
  if (!startYmd || !endYmd || startYmd > endYmd) return new Set();
  const y1 = parseInt(String(startYmd).slice(0, 4), 10);
  const y2 = parseInt(String(endYmd).slice(0, 4), 10);
  const set = new Set();
  for (let year = y1; year <= y2; year++) {
    const data = new FormData();
    data.append('function', 'getHolidays');
    data.append('year', String(year));
    try {
      const res = await execute(data, authUrl);
      const list = res?.data?.data?.holidays || res?.data?.data?.holidaysList || [];
      for (const h of list) {
        const d = h.holiday_date || h.holidayDate;
        if (d && d >= startYmd && d <= endYmd) set.add(d);
      }
    } catch {
      /* ignore; count weekdays only */
    }
  }
  return set;
}

export function countWorkingLeaveDays(startYmd, endYmd, holidayDateSet) {
  if (!startYmd || !endYmd) return 0;
  const start = new Date(`${startYmd}T12:00:00`);
  const end = new Date(`${endYmd}T12:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return 0;
  let n = 0;
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const dow = d.getDay();
    if (dow === 0 || dow === 6) continue;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const ymd = `${y}-${m}-${day}`;
    if (holidayDateSet && holidayDateSet.has(ymd)) continue;
    n++;
  }
  return n;
}
